import { Store } from '@tanstack/store'
import { env } from '@/env'
import { ensureSlash } from './ensure-slash'

export const appVersion = new Store(env.VITE_APP_VERSION)

appVersion.subscribe((version) => {
	if (version.currentVal) {
		// biome-ignore lint/suspicious/noConsole: We want to log the app version for debugging purposes.
		console.info(`${env.VITE_APP_TITLE} v${version.currentVal}`)
	}
})

export const apiUrl = new Store(env.VITE_API_URL || '')

export const signalRHubUrl = new Store(env.VITE_SIGNALR_HUB_URL || '')

export const oidcConfig = new Store(
	env.VITE_OIDC_CLIENT_ID
		? {
				issuerUri: env.VITE_OIDC_ISSUER_URI || '',
				clientId: env.VITE_OIDC_CLIENT_ID || '',
				redirectUri: env.VITE_OIDC_REDIRECT_URI || '',
				scope: env.VITE_OIDC_SCOPE || '',
			}
		: undefined,
)

export function setConfig(settings: Partial<ApiAppConfig>) {
	appVersion.setState(settings.appVersion || env.VITE_APP_VERSION)

	if (settings.apiUrl) {
		apiUrl.setState(ensureSlash(settings.apiUrl, false))
	}
	if (settings.signalR?.hubBaseUrl) {
		signalRHubUrl.setState(
			ensureSlash(settings.signalR.hubBaseUrl) + settings.signalR.path,
		)
	}
	if (settings.oidc) {
		oidcConfig.setState(settings.oidc)
	}
}

export interface ApiAppConfig {
	/** API URL */
	apiUrl: string

	/** App version */
	appVersion: string

	/** SignalR configuration */
	signalR: {
		hubBaseUrl?: string
		path?: string
	}

	/** OIDC configuration */
	oidc?: {
		issuerUri: string
		clientId: string
		redirectUri: string
		scope: string
	}
}
